export default {
    AlmeAPI : {
      ALME_API_REQUEST_TIMEOUT: 30000,
    },
    AlmeWeb: {
        rootScriptId: "nit-alme-main",
    },
    ExtensibleAlmeAPI: {
      EntitlementEndpoint: "Entitlement/{id}",
      ResponseMapEndpoint: "ResponseMapRetriever/getMap",
      UdpAiEndpoint:"UdpApiCall/getData",
      InitializationDataEndpoint: "InitData/getInitData",
      GetHistoryEndpoint: "ConversationSupport/GetHistory",
      notificationsApi: 'ConversationSupport/GetPendingMessages',
  },
};



// WEBPACK FOOTER //
// ./settings/alme-api.ts